module.exports = __webpack_public_path__ + "img/banner-2.2803f414.svg";